export const FETCH_PARTNER_START = 'FETCH_PARTNER_START';
export const FETCH_PARTNER_SUCCESS = 'FETCH_PARTNER_SUCCESS';
export const FETCH_PARTNER_FAILURE = 'FETCH_PARTNER_FAILURE';
export const CLEAR_PARTNER_SUCCESS = 'CLEAR_PARTNER_SUCCESS';